// DELEGATE EVENT LISTENER
export const delegateEventListener = (element, events, selector, callback) => {
    events.split(' ').forEach(event => {
        element.addEventListener(event, e => {
            if(!element.contains(e.target) || !e.target.closest(selector)) return
    
            callback.call(e.target, e)
        })
    })
}

// DEBOUNCE
export const debounce = (func, wait, immediate = false) => {
    let timeout
    
    return function executedFunction() {
        let context = this
        let args = arguments

        let later = function() {
            timeout = null
            if(!immediate) func.apply(context, args)
        }

        let callNow = immediate && !timeout

        clearTimeout(timeout)

        timeout = setTimeout(later, wait)

        if(callNow) func.apply(context, args)
    }
}